// Obtener la URL de la API desde las variables de entorno
export const API_URL = '/api';

// Otras configuraciones para el frontend
export const APP_NAME = process.env.REACT_APP_SITE_NAME || 'Hypothesis Games';

// Flag de depuración
export const DEBUG = process.env.REACT_APP_DEBUG === 'true';

// Log condicional (solo en modo depuración)
export const debugLog = (...args) => {
  if (DEBUG) {
    console.log(...args);
  }
};
